import * as React from 'react';
import { Checkbox, IDropdownOption, Label } from 'office-ui-fabric-react';
interface IProps {
    id: string;
    label: string;
    value: string; 
    options: IDropdownOption[];
    required: boolean;
    onChange: (val: string) => void;
}

export class CheckboxList extends React.Component<IProps, any> {

    onChange = (key: string, isChecked: boolean) => {
        let { value, onChange } = this.props;

        let values = value ? value.split(',') : [];

        if(isChecked) {
            values.push(key);
        }
        else {
            values = values.filter(v => v !== key);
        }

        value = values.length ? values.join(',') : null;

        onChange(value);
    }

    checkboxHtml = (option: IDropdownOption, i: number): JSX.Element => {
        let { id, value } = this.props;

        let values: string[] = value ? value.split(',') : [];
        
        return <Checkbox 
            key={'property_' + id + '_' + i}
            label={option.text}
            checked={ values.indexOf(option.key.toString()) >= 0}
            onChange={ (e, isChecked: boolean) => {
                this.onChange(option.key.toString(), isChecked);
            } }
        />;
    }

    public render() {

        let { value, options, label, required } = this.props;
        
        let checkboxes: JSX.Element[] = options && options.length ? options.map(this.checkboxHtml) : null;

        return (<div>
            {label ? <Label required={required}>{label}</Label> : null }
            {checkboxes}    
        </div>);
    }

}


// WEBPACK FOOTER //
// ./source/ts/components/common/checkbox-list.tsx